( function($) {
    $(document).ready(function(){
        setTimeout(() => {

            const opClass = '#featured-op tr';
            const opLength = $('#featured-op tr').length;

            const patentClass = '#tech-patent tr';
            const patentLength = $('#tech-patent tr').length;

            const softwareClass = '#tech-software tr';
            const softwareLength = $('#tech-software tr').length;

            const dataClass = '#data-software tr';
            const dataLength = $('#data-software tr').length;

            const recentPatentsClass = '#recent-patents tr';
            const recentPatentsLength = $('#recent-patents tr').length;

            var increment = 10;
            var recentPatentsIncrement = 26;

            if ( opLength < increment ) {
                $('.op-load-more').hide();
            };

            if ( patentLength < increment ) {
                $('.patent-load-more').hide();
            };

            if ( softwareLength < increment ) {
                $('.software-load-more').hide();
            };

            if ( dataLength < increment ) {
                $('.data-load-more').hide();
            };

            if ( recentPatentsLength < recentPatentsIncrement ) {
                $('.recent-patents-load-more').hide();
            };


            $(opClass+':lt('+increment+')').addClass('active');
            $(patentClass+':lt('+increment+')').addClass('active');
            $(softwareClass+':lt('+increment+')').addClass('active');
            $(dataClass+':lt('+increment+')').addClass('active');
            $(recentPatentsClass+':lt('+recentPatentsIncrement+')').addClass('active');

            $('.op-load-more').click((e) => {
                e.preventDefault();
                $(opClass).addClass('active');
                $('.op-load-more').hide();
            })

            $('.patent-load-more').click((e) => {
                e.preventDefault();
                $(patentClass).addClass('active');
                $('.patent-load-more').hide();
            })

            $('.software-load-more').click((e) => {
                e.preventDefault();
                $(softwareClass).addClass('active');
                $('.software-load-more').hide();
            })

            $('.data-load-more').click((e) => {
                e.preventDefault();
                $(dataClass).addClass('active');
                $('.data-load-more').hide();
            })

            $('.recent-patents-load-more').click((e) => {
                e.preventDefault();
                $(recentPatentsClass).addClass('active');
                $('.recent-patents-load-more').hide();
            })

        }, '1000');


    });

}( jQuery ) );